"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { usePathname } from "next/navigation";
import { fetchJobTypeClient } from "./fetchJobClient";
import { JobType } from "@/app/career/view-jobs/[id]/type";
import JobNotFound from "@/components/Job/JobNotFound";
import JobContainerExpired from "@/components/Job/JobNotFound/JobContainerExpired";
import { JobProvider } from "@/components/JobProvider";
export default function JobNotFoundHandler() {
  const $ = _c(10);
  const pathname = usePathname();
  const [jobInfo, setJobInfo] = React.useState();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!pathname) {
        return;
      }
      const pathnameWithOutSlash = pathname.startsWith("/") ? pathname.slice(1) : pathname;
      const fetchJobData = async () => {
        const job = await fetchJobTypeClient(pathname, pathnameWithOutSlash);
        setJobInfo(job);
      };
      fetchJobData();
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  const jobStatus = jobInfo?.type;
  const jobDetail = jobInfo?.data;
  const isNotFound = !jobInfo || jobInfo?.type === "not_found" || jobInfo?.type === "gone";
  const isExpired = jobStatus === "expired";
  if (isNotFound) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <JobNotFound />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (isExpired && jobDetail) {
    let t2;
    if ($[4] !== jobDetail) {
      t2 = <JobContainerExpired jobDetail={jobDetail} />;
      $[4] = jobDetail;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== jobDetail || $[7] !== t2) {
      t3 = <JobProvider jobDetail={jobDetail}>{t2}</JobProvider>;
      $[6] = jobDetail;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <JobNotFound />;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}